<template>
  <div id="processuser">
    <!-- 考区/考点工作人员信息管理 -->
    <!-- <small class="color-gray">考区/考点工作人员信息管理</small> -->
    <div class="mt-4">
      <template>
        <van-button type="info" size="small" class="w-25" round @click="pushUserList">添 加</van-button>
        <van-button
          type="info"
          size="small"
          class="ml-4 mr-4"
          plain
          round
          @click="downloadFile(apiFileDownLoad())"
        >下 载 模 板</van-button>
        <van-button type="info" size="small" class="w-25" round @click="dialogUpload = true">导 入</van-button>
      </template>
      <div>
        <el-form
          label-width="35%"
          label-position="left"
          class="m-4 text-left"
          v-for="(item, index) in userList"
          :key="index"
        >
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              角色名
            </template>
            <template>{{ item.RoleName }}</template>
          </el-form-item>

          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              职务
            </template>
            <template>{{ item.DutyName }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-user"></i>
              真实姓名
            </template>
            <template>{{ item.RealName }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw el-icon-phone"></i>
              联系电话
            </template>
            <template>{{ item.Phone }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw el-icon-c-scale-to-original"></i>
              身份证
            </template>
            <template>{{ item.UserIDCard }}</template>
          </el-form-item>
          <el-form-item size="mini" v-if="item.RoleID == RollleaderID">
            <template slot="label">
              车牌号
            </template>
            <template>{{ item.CarNo }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <van-button
              type="info"
              size="small"
              @click="
                getUserList(
                  item.UserID,
                  item.UserCount,
                  item.ReportNum,
                  item.RoleName,
                  item.RoleID,
                  item.DutyName,
                  item.Phone,
                  item.CarNo
                )
              "
            >编 辑</van-button>
            <van-button
              type="danger"
              style="margin-left:10px"
              size="small"
              @click="removeUser(item.UserID)"
            >删 除</van-button>
          </el-form-item>
        </el-form>
        <!-- <el-form
          label-width="35%"
          label-position="left"
          style="border-top:1px solid #ccc"
          class="m-4 text-left"
        >
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              角色名
            </template>
            <template>{{ userNumList.RoleName }}</template>
          </el-form-item>

          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-user"></i>
              工作人员人数
            </template>
            <template>共{{ userNumList.UserCount }}人</template>
          </el-form-item>
          <el-form-item size="mini">
            <van-button
              type="info"
              size="small"
              @click="
                getUserList(
                  userNumList.UserID,
                  userNumList.UserCount,
                  userNumList.ReportNum,
                  userNumList.RoleName,
                  userNumList.DutyName
                )
              "
            >编 辑</van-button>
          </el-form-item>
        </el-form>-->
        <div class="m-4 pb-4"></div>
      </div>
    </div>
    <!-- 添加考試任務彈出框 -->
    <el-dialog
      title="添加考务工作人员"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
    >
      <span>
        <el-form label-width="40%" label-position="left" class="m-4 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              角色名
            </template>
            <template>
              <el-select v-model="aaaaa" @change="change" placeholder="请选择">
                <el-option
                  v-for="item in roleList"
                  :key="item.RoleID"
                  :label="item.RoleName"
                  :value="item.RoleID"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>

          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              职务
            </template>
            <template>
              <el-input type="text" v-model="DutyName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              真实姓名
            </template>
            <template>
              <el-input type="text" v-model="name" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              联系电话
            </template>
            <template>
              <el-input type="number" v-model="photo" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              身份证
            </template>
            <template>
              <el-input type="text" v-model="pin" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini" v-if="aaaaa == RollleaderID">
            <template slot="label">
              车牌号
            </template>
            <template>
              <el-input type="text" v-model="CarNo" size="mini"></el-input>
            </template>
          </el-form-item>
        </el-form>
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="preserve">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 編輯彈窗 -->
    <el-dialog title="编辑考务工作人员" :visible.sync="dialogShow" width="90%" :before-close="handleClose">
      <span v-if="dialogVisibles">
        <el-form label-width="40%" label-position="left" class="m-2 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              角色名
            </template>
            <template>
              <el-select v-model="userSelList.RoleID" @change="change" placeholder="请选择" disabled>
                <el-option
                  v-for="item in roleList"
                  :key="item.RoleID"
                  :label="item.RoleName"
                  :value="item.RoleID"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>

          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              职务
            </template>
            <template>
              <el-input type="text" v-model="userSelList.DutyName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              真实姓名
            </template>
            <template>
              <el-input type="text" v-model="userSelList.RealName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              联系电话
            </template>
            <template>
              <el-input type="number" v-model="userSelList.Phone" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color:red">*</span>
              身份证
            </template>
            <template>
              <el-input type="text" v-model="userSelList.UserIDCard" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini" v-if="userSelList.RoleID == RollleaderID">
            <template slot="label">
              <span style="color:red">*</span>
              车牌号
            </template>
            <template>
              <el-input type="text" v-model="userSelList.CarNo" size="mini"></el-input>
            </template>
          </el-form-item>
        </el-form>
      </span>
      <span v-if="dialogNumShow">
        <el-form label-position="left" class="m-4 text-left">
          <el-form-item size="mini" label-width="30%">
            <template slot="label">角色名</template>
            <template>
              <el-input :disabled="true" type="text" v-model="userNumList.RoleName" size="mini"></el-input>
            </template>
          </el-form-item>

          <el-form-item size="mini" label-width="35%">
            <template slot="label">工作人员人数</template>
            <template>
              <el-input type="text" v-model="userNumList.UserCount" size="mini"></el-input>
            </template>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="setUser">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>工作任务加载中...</van-loading>
      </div>
    </van-overlay>
    <el-dialog
      title="考务人员导入"
      :visible.sync="dialogUpload"
      width="90%"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
      @dragDialog="handleDrag"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="rules"
        v-loading="loading"
        element-loading-text="正在检测数据。。。"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- :on-success="uploadSuccess" -->
        <el-upload
          :action="fileUrl"
          :on-error="uploadError"
          :data="dataId"
          :on-success="uploadSuccess"
          :file-list="fileList"
          :headers="headers"
          :before-remove="beforeRemove"
          multiple
          :on-change="handleChange"
          :auto-upload="true"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
        <!-- 上传进度条 -->
        <el-progress :percentage="progress" :style="uploadPercen"></el-progress>
        <el-alert title="只能上传.xlsx, .xls, .csv，.txt，.accdb文件" type="success" :closable="false"></el-alert>
        <el-form-item prop="table">
          <el-select
            @change="handleSelectTable"
            placeholder="请选择表(必选)"
            v-model="formData.TableName"
            style="width:100%"
            clearable
          >
            <el-option
              v-for="(item, index) in userInfoTable"
              :label="item"
              :key="index"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="RealName">
          <el-select
            placeholder="真实姓名(必选)"
            v-model="formData.RealName"
            clearable
            style="width:100%"
          >
            <el-option v-for="(item, index) in tableField" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="Phone">
          <el-select placeholder="电话号码(必选)" v-model="formData.Phone" clearable style="width:100%">
            <el-option v-for="(item, index) in tableField" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="UserIDCard">
          <el-select
            placeholder="身份证号码(必选)"
            v-model="formData.UserIDCard"
            clearable
            style="width:100%"
          >
            <el-option v-for="(item, index) in tableField" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="RoleName">
          <el-select
            placeholder="角色名称(必选)"
            v-model="formData.RoleName"
            clearable
            style="width:100%"
          >
            <el-option v-for="(item, index) in tableField" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="DutyName">
          <el-select
            placeholder="职务名称(必选)"
            v-model="formData.DutyName"
            clearable
            style="width:100%"
          >
            <el-option v-for="(item, index) in tableField" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="CarNo">
          <el-select placeholder="车牌号(可选)" v-model="formData.CarNo" clearable style="width:100%">
            <el-option v-for="(item, index) in tableField" :label="item" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-tag size="medium" >
          <span @click="downloadFile(apiFileDownLoad())">下载模板</span>
        </el-tag>-->
        <el-button @click="dialogUpload = false">取 消</el-button>
        <el-button type="primary" @click="handleImportData">确 定</el-button>
      </span>
      <!-- 错误弹窗 -->
      <!-- <el-dialog :title="messageErr" :visible.sync="dialogVisibleErr" append-to-body>
        <el-table :data="errData.message" style="width: 100%" height="350">
          <el-table-column
            v-for="(item, index) in errData.columns"
            :key="index"
            :label="item.title"
            :prop="item.field"
          ></el-table-column>
        </el-table>
      </el-dialog>-->
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "processuser",
  data() {
    return {
      aaaaa: "",
      RollleaderID: -1,
      userList: [],
      dataId: {
        WorkID: this.getWork().WorkID
      },
      userNumList: [],
      userSelList: [],
      roleList: [],
      dialogVisible: false,
      dialogVisibles: false,
      dialogNumShow: false,
      dialogShow: false, //編輯彈窗是否顯示
      overlayshow: false, // 遮罩层
      RoleID: "",
      UserID: "",
      UserCount: "",
      ReportNum: "",
      RoleName: "",
      name: "",
      photo: "",
      pin: "",
      CarNo: "",
      DutyName: "", //职务
      incident: "", //1 添加工作人員  2 編輯資料    3  編輯人數
      generalReport: {
        WorkID: "",
        SplitProcessID: "",
        Status: 2,
        Memo: "",
        OrganID: null,
        RoleID: null
      },
      dialogUpload: false,
      organID: "",
      formData: {
        WorkID: "",
        module: "",
        FileName: "",
        TableName: "",
        OrganID: "",
        RoleTypeID: null,
        AreaID: null,
        AddrID: null,
        RealName: "",
        UserIDCard: "",
        Phone: "",
        RoleName: "",
        DutyName: "",
        CarNo: ""
      },
      rules: {
        FileName: [
          { required: true, message: "请选择文件", trigger: "change" }
        ],
        RealName: [
          { required: true, message: "姓名为必选项", trigger: "change" }
        ],
        Phone: [{ required: true, message: "电话为必选项", trigger: "change" }],
        UserIDCard: [
          { required: true, message: "身份证号码为必选项", trigger: "change" }
        ],
        DutyName: [
          { required: true, message: "职务名称为必选项", trigger: "change" }
        ],
        RoleName: [
          { required: true, message: "角色为必选项", trigger: "change" }
        ]
      }, //表单验证
      upLoadData: {}, //上传数据
      fileList: [], //上传文件列表
      userInfoTable: {}, //选择列表数据
      tableField: {}, //字段数据
      fileName: null, //文件名
      module: null, //文件保存目录名
      loading: false,
      // 上传文件
      disabled: false, //上传文件功能是否禁用
      uploadPercen: "display:none;", //上传进度条
      progress: 0, //上传进度
      totalcount: 0, //上传总数量
      count: 0, //上传开始数
      dialogVisibleErr: false, //错误弹窗
      messageErr: "", //错误提示
      errData: [] //错误数据
    };
  },
  created() {
    this.fetchData();
    // eslint-disable-next-line no-console
    this.headers = this.getprocessuserUploadFile();
    this.fileUrl = this.apiprocessuserUploadFileAPIPost();
    // console.log(this.getAddr());
    // console.log( this.apiprocessuserUploadFileAPIPost());
    this.completeBtnAttribute.tips = "需要先添加考务人员信息后上报状态";
    this.verifiupdateData();
  },
  watch: {
    dialogUpload(val) {
      if (val == false) {
        this.dialogUpload = false;
        this.handleClear();
      }
    }
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    fetchData() {
      this.userList = [];
      this.apireportGetrolelistAPIGet(
        {
          WorkID: this.getWork().WorkID,
          RoleTypeID: this.getAddr().RoleTypeID
        },
        this,
        res => {
          // eslint-disable-next-line no-console
          this.roleList = res.data;
          //循环判断领卷人ID
          res.data.forEach(res => {
            if (res.RoleName == "领卷人") {
              this.RollleaderID = res.RoleID;
            }
          });
          // console.log(this.roleList);
        }
      );
      if (this.getAddr().OrganType == 1) {
        this.apireportGetuserlistAPIGet(
          {
            WorkID: this.getWork().WorkID,
            AreaID: 0,
            AddrID: 0
          },
          this,
          res => {
            res.data.forEach(element => {
              if (element.ReportNum == 0) {
                this.userList.push(element);
              } else {
                this.userNumList = element;
              }
            });
          }
        );
      } else if (this.getAddr().OrganType == 2) {
        this.apireportGetuserlistAPIGet(
          {
            WorkID: this.getWork().WorkID,
            AreaID: this.getAddr().RangeID,
            AddrID: 0
          },
          this,
          res => {
            res.data.forEach(element => {
              if (element.ReportNum == 0) {
                this.userList.push(element);
              } else {
                this.userNumList = element;
              }
            });
          }
        );
      } else if (this.getAddr().OrganType == 3) {
        this.apireportGetuserlistAPIGet(
          {
            WorkID: this.getWork().WorkID,
            AreaID: 0,
            AddrID: this.getAddr().RangeID
          },
          this,
          res => {
            // eslint-disable-next-line no-console
            // console.log(res);

            res.data.forEach(element => {
              if (element.ReportNum == 0) {
                this.userList.push(element);
              } else {
                this.userNumList = element;
              }
            });
          }
        );
      }
      this.verifiupdateData();
    },
    // 添加按鈕  显示弹窗
    pushUserList() {
      this.dialogVisible = true;
      this.dialogVisibles = true;
    },
    // 編輯按鈕
    getUserList(
      UserID,
      UserCount,
      ReportNum,
      RoleName,
      RoleID,
      DutyName,
      photo,
      CarNo
    ) {
      // console.log(UserID, UserCount, ReportNum, RoleName, RoleID);
      // console.log(photo);

      this.dialogShow = true;
      this.UserID = UserID;
      this.UserCount = UserCount;
      this.ReportNum = ReportNum;
      this.RoleName = RoleName;
      this.RoleID = RoleID;
      this.DutyName = DutyName;
      this.photo = photo;
      this.CarNo = CarNo;
      // this.dialogVisible = true;
      if (UserCount == 0) {
        this.dialogVisibles = true;
        this.dialogNumShow = false;
        if (this.getAddr().OrganType == 2) {
          this.apireportGetuserlistAPIGet(
            {
              WorkID: this.getWork().WorkID,
              AreaID: this.getAddr().RangeID,
              AddrID: 0
            },
            this,
            res => {
              // eslint-disable-next-line no-console
              // console.log(res);
              this.userSelList = [];
              res.data.forEach(element => {
                if (element.ReportNum == 0 && UserID == element.UserID) {
                  this.userSelList = element;
                }
              });
              // eslint-disable-next-line no-console
              console.log(this.userSelList);
            }
          );
        }
        if (this.getAddr().OrganType == 3) {
          this.apireportGetuserlistAPIGet(
            {
              WorkID: this.getWork().WorkID,
              AreaID: 0,
              AddrID: this.getAddr().RangeID
            },
            this,
            res => {
              // eslint-disable-next-line no-console
              // console.log(res);
              this.userSelList = [];
              res.data.forEach(element => {
                if (element.ReportNum == 0 && UserID == element.UserID) {
                  this.userSelList = element;
                }
              });
              // eslint-disable-next-line no-console
              console.log(this.userSelList);
            }
          );
        }
      } else {
        this.dialogNumShow = true;
        this.dialogVisibles = false;
      }
    },
    // 添加工作人员  保存按鈕
    preserve() {
      if (this.name == "") {
        Dialog.alert({
          title: "提示",
          message: "真实姓名不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.photo == "") {
        Dialog.alert({
          title: "提示",
          message: "联系电话不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.DutyName == "") {
        Dialog.alert({
          title: "提示",
          message: "职务不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.pin == "") {
        Dialog.alert({
          title: "提示",
          message: "身份证不能为空"
        }).then(() => {
          // on close
        });
      } else {
        this.overlayshow = true; // 显示遮罩层
        this.apiReportAdduserinfoAPIGet(
          {
            WorkID: this.getWork().WorkID,
            RoleID: this.RoleID,
            RoleTypeID: this.getAddr().RoleTypeID,
            AreaID: this.getAddr().RangeID,
            AddrID: this.getAddr().RangeID,
            OrganID: this.getAddr().OrganID,
            RealName: this.name,
            Phone: this.photo,
            DutyName: this.DutyName,
            UserIDCard: this.pin,
            CarNo: this.CarNo
          },
          this,
          res => {
            // console.log(this.userList);
            this.overlayshow = false; // 显示遮罩层
            if (res.code == 20000) {
              this.dialogVisible = false;
              this.name = "";
              this.photo = "";
              this.pin = "";
              this.CarNo = "";
              this.roleList = [];
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchData();
            } else {
              this.$toast(res.message);
            }
            if (res.code == 50000) {
              this.dialogVisible = false;
              this.$message.error(res.message);
              this.fetchData();
              return;
            }
          }
        );
      }
    },
    // 编辑工作人员  保存按鈕
    setUser() {
      // console.log(this.userSelList);

      if (this.ReportNum == 0) {
        if (this.userSelList.DutyName == "") {
          Dialog.alert({
            title: "提示",
            message: "职务不能为空"
          }).then(() => {
            // on close
          });
        } else if (this.userSelList.Phone == "") {
          Dialog.alert({
            title: "提示",
            message: "联系电话不能为空"
          }).then(() => {
            // on close
          });
        } else if (this.userSelList.UserIDCard == "") {
          Dialog.alert({
            title: "提示",
            message: "身份证不能为空"
          }).then(() => {
            // on close
          });
        } else if (this.userSelList.RealName == "") {
          Dialog.alert({
            title: "提示",
            message: "真实姓名不能为空"
          }).then(() => {
            // on close
          });
        } else {
          this.apiSetuserinfoAPIGet(
            {
              WorkID: this.getWork().WorkID,
              RoleID: this.RoleID,
              RoleTypeID: this.getAddr().RoleTypeID,
              AreaID:
                this.getAddr().OrganType == 2 ? this.getAddr().RangeID : 0,
              AddrID:
                this.getAddr().OrganType == 3 ? this.getAddr().RangeID : 0,
              RealName: this.userSelList.RealName,
              ReportNum: this.ReportNum,
              Phone: this.userSelList.Phone,
              DutyName: this.userSelList.DutyName,
              UserID: this.UserID,
              UserCount: this.userNumList.UserCount,
              UserIDCard: this.userSelList.UserIDCard,
              CarNo: this.userSelList.CarNo
            },
            this,
            res => {
              if (res.code == 20000) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.fetchData();
                this.dialogShow = false;
              } else {
                this.$toast(res.message);
              }
              if (res.code == 50000) {
                // this.dialogVisible = false;
                this.$message.error(res.message);
                this.fetchData();
                return;
              }
            }
          );
        }
      }
      if (this.ReportNum == 1) {
        if (this.userNumList.UserCount != "") {
          this.apiSetuserinfoAPIGet(
            {
              AreaID: this.getAddr().RangeID,
              AddrID: this.getAddr().RangeID,
              OrganID: this.getAddr().OrganID,
              RangeID: this.getAddr().RangeID,
              ReportNum: this.ReportNum,
              DutyName: this.DutyName,
              RoleID: "14",
              Phone: this.photo,
              RoleName: this.RoleName,
              RoleTypeID: this.getAddr().RoleTypeID,
              WorkID: this.getWork().WorkID,
              UserCount: this.userNumList.UserCount
            },
            this,
            res => {
              if (res.code == 20000) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.fetchData();
                this.dialogShow = false;
              }
              if (res.code == 50000) {
                // this.dialogVisible = false;
                this.$message.error(res.message);
                this.fetchData();
                return;
              }
            }
          );
        } else {
          Dialog.alert({
            title: "提示",
            message: "工作人员人数不能为空"
          }).then(() => {
            // on close
          });
        }
      }
    },
    // 刪除工作人員
    removeUser(userID) {
      Dialog.confirm({
        title: "提示",
        message: "此操作将永久删除, 是否继续?"
      })
        .then(() => {
          this.apiReportDeluserinfofoAPIGet(
            { WorkID: this.getWork().WorkID, UserID: userID },
            this,
            // eslint-disable-next-line no-unused-vars
            res => {
              this.fetchData();
            }
          );
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    change(element) {
      this.RoleID = element;
    },
    getProcessUserFieldData(val) {
      // 获取字段
      this.apigetexamlist(
        {
          WorkID: this.getWork().WorkID,
          FileName: this.fileName,
          TableName: val,
          module: this.module
        },
        this,
        res => {
          // eslint-disable-next-line no-console
          console.log(res);

          this.tableField = res.data.FieldList;
        }
      );
    },
    handleSelectTable(val) {
      // 切换表
      if (val !== "") {
        this.getProcessUserFieldData(val);
      }
    },
    handleImportData() {
      // 导入数据
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.loading = true;
          this.formData.WorkID = this.workid;
          // this.formData.FileName = this.fileName
          (this.formData.OrganID = this.getAddr().OrganID),
            (this.formData.RoleTypeID = this.getAddr().RoleTypeID);
          if (this.getAddr().RoleTypeID == 1) {
            this.formData.AreaID = 0;
            this.formData.AddrID = 0;
          } else if (this.getAddr().RoleTypeID == 2) {
            this.formData.AreaID = this.getAddr().RangeID;
            this.formData.AddrID = 0;
          } else {
            this.formData.AreaID = 0;
            this.formData.AddrID = this.getAddr().RangeID;
          }

          this.apiimportDataFileAPIPost(
            {
              WorkID: this.getWork().WorkID,
              module: this.formData.module,
              FileName: this.formData.FileName,
              TableName: this.formData.TableName,
              OrganID: this.formData.OrganID,
              RoleTypeID: this.formData.RoleTypeID,
              AreaID: this.formData.AreaID,
              AddrID: this.formData.AddrID,
              RealName: this.formData.RealName,
              UserIDCard: this.formData.UserIDCard,
              Phone: this.formData.Phone,
              RoleName: this.formData.RoleName,
              DutyName: this.formData.DutyName,
              CarNo: this.formData.CarNo
            },
            this,
            response => {
              if (response.code == 20000) {
                this.loading = false;
                this.dialogUpload = false;
                this.fetchData();
              } else if (response.code == 20021) {
                this.messageErr = response.message;
                this.errData = response.data;
                this.dialogVisibleErr = true;
              } else if (response.code == 20022) {
                this.$message({
                  type: "warning",
                  message: response.message
                });
              } else {
                this.$message({
                  type: "success",
                  message: "提交成功!"
                });
                this.$emit("isUpdate");
                this.loading = false;
                this.handleClose();
              }
              this.$toast(response.message);
              this.loading = false;
              /* this.loading = false;
              this.dialogUpload = false;
              this.fetchData(); */
            }
          );
          // eslint-disable-next-line no-unused-vars
          /* .catch(err => {
              this.$emit("isUpdate");
              this.loading = false;
              this.handleClose();
            }); */
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogUpload = false;
      this.dialogShow = false;
    },
    // eslint-disable-next-line no-unused-vars
    uploadError(response, file, fileList) {
      this.$notify.error({
        title: "Error",
        message: "上传失败。"
      });
    },
    // eslint-disable-next-line no-unused-vars
    beforeRemove(file, fileList) {
      // 移除之前确认
      // return this.$confirm(`确定移除 ${file.name}？`);
      this.$notify({
        title: "警告",
        message: "不可删除",
        type: "warning"
      });
      return false; // 关闭移除
    },
    // 文件选择
    handleChange(file, fileLists) {
      this.fileList = fileLists.slice(-1);
      this.upLoadData = file.raw;
      this.upLoadData["WorkID"] = this.workid;
      this.disabled = true;
    },
    handleClear() {
      this.$refs.formData.resetFields();
      this.userInfoTable = {};
      (this.formData = {
        WorkID: "",
        module: "",
        FileName: "",
        TableName: "",
        OrganID: "",
        RoleTypeID: null,
        AreaID: null,
        AddrID: null,
        RealName: "",
        UserIDCard: "",
        Phone: "",
        RoleName: "",
        DutyName: "",
        CarNo: ""
      }),
        (this.tableField = {});
      this.fileList = [];
    },
    handleDrag() {
      //this.$refs.select.blur()
    },
    // eslint-disable-next-line no-unused-vars
    uploadSuccess(response, file, fileList) {
      this.userInfoTable = response.data.TableList;
      this.fileName = response.data.FileName;
      this.formData.FileName = response.data.FileName;
      this.module = response.module;
      this.formData.module = response.module;
      // 判断权限
      this.formData.OrganID = this.organID;
      this.formData.AddrID = this.addrID;
      // eslint-disable-next-line no-constant-condition
      if ((response.code = 20000)) {
        // 初始化
        this.$notify({
          title: "Success",
          message: "上传成功。",
          type: "success",
          duration: 2000
        });
      }
    },
    verifiupdateData() {
      this.apiProcessuserReportAllowreportGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          RoleTypeID: this.getAddr().RoleTypeID
        },
        this,
        res => {
          if (res.data == 1) {
            this.completeBtnAttribute.disabled = false;
          } else {
            this.completeBtnAttribute.disabled = true;
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.el-dialog__body {
  padding: 1px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>